import './classes/Header.css';
import { configData } from "../config";
import { useAuth } from "../AuthContext";
import React, { useState, useEffect, useRef} from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping, faBars, faBolt, faBook, faCalculator, faCashRegister, faChartLine, faEllipsisV, faGear, faPlus, faUserCog, faUserGroup, faXmark } from '@fortawesome/free-solid-svg-icons';

const Header = () => {

    // const [user, setUser] = useState(null);
    const app_url = configData.APP_URL;
    const { user, setUser, setLoading } = useAuth();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const [open, setOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(prev => !prev);
    };

    const location = useLocation();

    const path = location.pathname;
    const loginpage = path.includes('/user');

    // Logout function
    const handleLogout = async () => {
        try {
            await fetch(app_url + "site/logout", {
                method: "POST",
                credentials: "include",
            });
        } catch (error) {
            console.error("Logout error:", error);
        }
        setLoading(true);
        setUser(null);
        localStorage.removeItem("user");
        window.location.href="/user";
    };

    useEffect(() => {
        const media = window.matchMedia("(max-width: 850px)");

        const updateSidebar = () => {
            setIsSidebarOpen(!media.matches);
        };

        updateSidebar();

        media.addEventListener("change", updateSidebar);
        return () => media.removeEventListener("change", updateSidebar);
    }, []);

    return (

        <header className="header"> 
        
            {/* {(user && user.company_id) && */}
            {user &&
                <>
                    {!isSidebarOpen ? 
                    (<FontAwesomeIcon icon={faBars} onClick={() => {toggleSidebar(); setOpen(false);}} className="menu-toggle" />) :
                    (<FontAwesomeIcon icon={faXmark} onClick={toggleSidebar} className="menu-toggle" />)}
                </>
            }
            <div className="flex">
                <img
                    src="/images/icon.png"
                    alt="Logo"
                    className=""
                />
                <span className="app-name">
                    Retail POS
                </span>
                {/* {(user && user.company_id) &&  */}
                {user && 
                    <div className={`sidebar-wrapper ${isSidebarOpen ? "open" : "closed"}`}>
                        <div className="sidebar-container">
                            <h3>
                                <FontAwesomeIcon className="sidebar-bolt-icon" icon={faBolt} />
                                Quick Actions
                            </h3>
                            <ul>
                                <li>
                                <a href="/sales">
                                    <FontAwesomeIcon icon={faBagShopping} />&nbsp;
                                    <span>Sales</span>
                                </a>
                                </li>
                                <li>
                                <a href="/sales-by-display">
                                    <FontAwesomeIcon icon={faCashRegister} />&nbsp;
                                    <span>Sales by Display</span>
                                </a>
                                </li>
                                {user.role === 3 &&
                                <li>
                                <a href="/estimate">
                                    <FontAwesomeIcon icon={faCalculator} />&nbsp;
                                    <span>Estimate</span>
                                </a>
                                </li>}
                                {(user.role === 1 || user.role === 3) &&
                                    <>
                                        <li>
                                        <a href="/manage-items">
                                            <FontAwesomeIcon icon={faPlus} />&nbsp;
                                            <span>Items</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href="/manage-customers">
                                            <FontAwesomeIcon icon={faUserGroup} />&nbsp;
                                            <span>Customers</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href="/manage-users">
                                            <FontAwesomeIcon icon={faUserCog} />&nbsp;
                                            <span>Users</span>
                                        </a>
                                        </li>
                                        <li>
                                        <a href="/sales-report">
                                            <FontAwesomeIcon icon={faChartLine} />&nbsp;
                                            <span>Sales Report</span>
                                        </a>
                                        </li>
                                        {user.role === 3 &&
                                        <li>
                                        <a href="/estimate-report">
                                            <FontAwesomeIcon icon={faBook} />&nbsp;
                                            <span>Estimate Report</span>
                                        </a>
                                        </li>}
                                        <li>
                                        <a href="/company-setup/edit">
                                            <FontAwesomeIcon icon={faGear} />&nbsp;
                                            <span>Edit Company</span>
                                        </a>
                                        </li>
                                    </>
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>

            <div>
                <ul style={{padding: "0px"}}>
                    {user ? (
                        <>
                            {/* Desktop View */}
                            <li className="desktop-user">
                            Hi, {user.username}
                            </li>
                            <li className="desktop-user">
                            <a onClick={handleLogout}>Logout</a>
                            </li>

                            {/* Mobile Avatar */}
                            <li className="mobile-user">
                            <div
                                className="avatar"
                                onClick={() => {setOpen(prev => !prev); setIsSidebarOpen(false);}}
                            >
                                {user.username.charAt(0).toUpperCase()}
                            </div>

                            {open && (
                                <div className="dropdown">
                                <p className='username'>Hi, {user.username}</p>
                                <button onClick={handleLogout}>Logout</button>
                                </div>
                            )}
                            </li>
                        </>
                    ) : (
                        <>{!loginpage &&
                        <li><a href="/user">Login</a></li>}</>
                    )}
                </ul>
            </div>
        </header>
    );
};

export default Header;